import { trackPageView } from "app/containers/Global/slice";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "utils/redux/hooks";

const useTrackPage = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      trackPageView({
        pathName: location.pathname,
        queryParams: location.search,
      })
    );
  }, [location, dispatch]);
};

export default useTrackPage;
